import React, { useState } from 'react'
import styled from 'styled-components'
import orderBy from 'lodash/orderBy'

import {
  Form,
  FormGroup,
  Modal,
} from 'reactstrap'
import { AiOutlineSave } from 'react-icons/ai'
import { CustomDatePicker } from '../datepicker'
import { Input, SearchSelect } from '../input'
import { CloseIcon } from '../icons'
import { Button } from '../buttons'

import { FONTS } from '../../constants'

export const CreateForm = ({ isCreate, handleClickCreate, lobList, createSaleProduct }) => {
  const [detailState, setDetailState] = useState({})

  const handleInput = (e, name) => {
    if (name === 'lob_id') {
      setDetailState({ ...detailState, lob_id: e.value })
    } else {
      setDetailState({ ...detailState, [name]: e })
    }
  }

  const resetState = () => {
    setDetailState({})
    handleClickCreate()
  }

  return (
    <Modal isOpen={ isCreate } toggle={ resetState }>
      <ModalHeader>
        <Header>Create Sale Product</Header>
        <CloseIcon
          onClick={ () => resetState }
        />
      </ModalHeader>
      <FormWrapper>
        <Form>
          <FormGroup>
            <Label>Code</Label>
            <Input
              name='product_code'
              placeholder='Enter Code'
              onChange={ e => handleInput(e.target.value, 'product_code') }
            />
          </FormGroup>
          <FormGroup>
            <Label>Name</Label>
            <Input
              name='name'
              placeholder='Enter Name'
              onChange={ e => handleInput(e.target.value, 'name') }
            />
          </FormGroup>
          <FormGroup>
            <Label>LOB</Label>
            <SearchSelect
              name='lob_id'
              placeholder='Enter LOB'
              onChange={ e => handleInput(e, 'lob_id') }
              options={ orderBy(lobList, 'label', 'asc') }
            />
          </FormGroup>
          <FormGroup>
            <Label>Start date</Label>
            <CustomDatePicker
              showYearDropdown
              showMonthDropdown
              autoComplete='off'
              name='start_date'
              dateFormat='DD/MM/YYYY'
              selected={ detailState.start_date }
              onChange={ e => handleInput(e, 'start_date') }
            />
          </FormGroup>
          <FormGroup>
            <Label>End Date</Label>
            <CustomDatePicker
              showYearDropdown
              showMonthDropdown
              autoComplete='off'
              name='end_date'
              dateFormat='DD/MM/YYYY'
              selected={ detailState.end_date }
              onChange={ e => handleInput(e, 'end_date') }
            />
          </FormGroup>
        </Form>
      </FormWrapper>
      <Footer>
        <ButtonGroup>
          <Button
            theme='#28a745'
            icon={ <AiOutlineSave style={ { fontSize: 16 } } /> }
            width='70px'
            height='26px'
            onClick={ () => {
              createSaleProduct(detailState)
              setDetailState({})
            } }
          >
            Save
          </Button>
          <Button
            theme='#6c757d'
            width='70px'
            height='26px'
            onClick={ resetState }
          >
            Close
          </Button>
        </ButtonGroup>
      </Footer>
    </Modal>
  )
}


const ModalHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 16px 0 16px;
`

const Header = styled.span`
  font-family: ${FONTS.GOTHAM_BOLD};
  font-size: ${FONTS.TITLE_SIZE};
  color: #333333;
`

const Footer = styled.div`
  height: 42px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background: #F9F9F9;
  padding: 0 16px;
`

const Label = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  color: #808080;
`

const FormWrapper = styled.div`
  min-height: 500px;
  padding: 24px 16px;
`

const ButtonGroup = styled.div`
  display: flex;

  div:nth-child(1) {
    margin-right: 12px;
  }
`



// WEBPACK FOOTER //
// ./src/components/sale-product/create-form.js